import { requestGQL } from 'common/graphQlClient';
import { useMutation, useQueryClient } from 'react-query';

import { allPremisesKey } from 'app/premises/hooks/usePremisesList';
import { DELETE_TPOUTLET_PHOTO, TPOutletPhotoUpload } from '../api';

export const useMutateDeleteTpOutletPhoto = (propertyId: null | number) => {
  const queryClient = useQueryClient();

  const { data, mutate, isLoading, isError, isSuccess } = useMutation<string, unknown, TPOutletPhotoUpload>(
    async (outletPhotoDelete) => requestGQL(DELETE_TPOUTLET_PHOTO, outletPhotoDelete),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['propertyConnection', propertyId]);
        queryClient.invalidateQueries(allPremisesKey(propertyId));
      },
    },
  );

  return { data, mutate, isLoading, isError, isSuccess };
};
